import Alert from "@mui/material/Alert";
import { getErrorMessage } from "@/shared/utils/errorCodes";
import type { ReactNode } from "react";

const extractErrorCode = (gqlError: any): string | undefined => {
  return gqlError?.extensions?.code;
};

export interface ErrorMessageProps {
  error: any;
  actions?: ReactNode; // Готовые React компоненты (кнопки)
}

interface AlertContentProps {
  message: string;
  errorCode?: string;
  actions?: ReactNode;
}

const AlertContent: React.FC<AlertContentProps> = ({
  message,
  errorCode,
  actions,
}) => {
  const processedMessage = getErrorMessage(errorCode, message);

  return (
    <Alert variant="filled" severity="error" action={actions}>
      {processedMessage}
    </Alert>
  );
};

export const ErrorMessage: React.FC<ErrorMessageProps> = ({
  error,
  actions,
}) => {
  if (!error) return null;

  if (error.graphQLErrors && error.graphQLErrors.length) {
    return (
      <>
        {error.graphQLErrors.map((gqlError: any, i: number) => {
          const errorCode = extractErrorCode(gqlError);

          return (
            <AlertContent
              key={i}
              message={gqlError.message}
              errorCode={errorCode}
              actions={actions}
            />
          );
        })}
      </>
    );
  }

  if (
    error.networkError &&
    error.networkError.result &&
    error.networkError.result.errors
  ) {
    return (
      <>
        {error.networkError.result.errors.map((err: any, i: number) => {
          const errorCode = extractErrorCode(err);

          return (
            <AlertContent
              key={i}
              message={err.message}
              errorCode={errorCode}
              actions={actions}
            />
          );
        })}
      </>
    );
  }

  return <AlertContent message={error.message} actions={actions} />;
};
